// extracted by mini-css-extract-plugin
export default {"list":"ShareButton_list__I5So8","item":"ShareButton_item__n6Wqi","title":"ShareButton_title__+z3TN","icon":"ShareButton_icon__LckeE"};